module.exports = __webpack_public_path__ + "static/media/addimg.17d95c21.png";